export default __webpack_public_path__ + "41c0240bac6c82c873ee61662cd16211.png";